import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import CourseModules from "./components/CourseModules";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ToastContainer from "./components/Toast";
import CppApp from "./components/cpp-course/CppApp";
import WebsiteSelector from "./components/WebsiteSelector";
import LithiumTeaser from "./components/LithiumTeaser";
import SolarTeaser from "./components/SolarTeaser";
import DroneTeaser from "./components/DroneTeaser";
import { LanguageProvider } from "./contexts/LanguageContext";
import { useToast } from "./hooks/useToast";
import { Analytics } from '@vercel/analytics/react';

function QubitCenterApp() {
  const { toasts, removeToast } = useToast();
  
  return (
    <div className="App" style={{ backgroundColor: 'var(--bg-page)' }}>
      <Header />
      <Hero />
      <CourseModules />
      <Features />
      <Testimonials />
      <Contact />
      <Footer />
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WebsiteSelector />} />
          <Route path="/cpp-course" element={<CppApp />} />
          <Route path="/qubit-center" element={<QubitCenterApp />} />
          <Route path="/lithium-teaser" element={<LithiumTeaser />} />
          <Route path="/solar-teaser" element={<SolarTeaser />} />
          <Route path="/drone-teaser" element={<DroneTeaser />} />
        </Routes>

        {/* Add Analytics here */}
        <Analytics />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
